/*
 * @Author: your name
 * @Date: 2021-07-09 11:35:18
 * @LastEditTime: 2021-07-31 15:38:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\static\data\fontSize.js
 */
const fontSize = [12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100];
export default fontSize;